<!-- Stunning Navigation -->
<nav class="premium-navbar" [class.scrolled]="isScrolled">
  <div class="nav-container">
    <div class="brand-section">
      <div class="logo-wrapper">
        <div class="logo-icon">🎓</div>
        <div class="brand-info">
          <h1 class="brand-name">{{ 'COMMON.APP_NAME' | translate }}</h1>
          <span class="brand-tagline">{{ 'HOME.NAV.TAGLINE' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="nav-links">
      <a (click)="smoothScroll('home', $event)" class="nav-link active">
        <span class="link-text">{{ 'HOME.NAV.HOME' | translate }}</span>
        <div class="link-underline"></div>
      </a>
      <a (click)="smoothScroll('about', $event)" class="nav-link">
        <span class="link-text">{{ 'HOME.NAV.ABOUT' | translate }}</span>
        <div class="link-underline"></div>
      </a>
      <div class="nav-dropdown">
        <a href="#" class="nav-link dropdown-trigger">
          <span class="link-text">{{ 'HOME.NAV.PLATFORM' | translate }}</span>
          <i class="dropdown-arrow">▼</i>
          <div class="link-underline"></div>
        </a>
        <div class="dropdown-content">
          <a (click)="smoothScroll('features', $event)" class="dropdown-item">
            <span class="item-icon">⚡</span>
            <span>{{ 'HOME.NAV.FEATURES' | translate }}</span>
          </a>
          <a (click)="smoothScroll('demo', $event)" class="dropdown-item">
            <span class="item-icon">📹</span>
            <span>{{ 'HOME.NAV.DEMO' | translate }}</span>
          </a>
          <a (click)="smoothScroll('platform-features', $event)" class="dropdown-item">
            <span class="item-icon">🚀</span>
            <span>{{ 'HOME.NAV.PLATFORM_FEATURES' | translate }}</span>
          </a>
          <a href="#" class="dropdown-item">
            <span class="item-icon">📚</span>
            <span>{{ 'HOME.NAV.DOCUMENTATION' | translate }}</span>
          </a>
        </div>
      </div>
      <a (click)="smoothScroll('offers', $event)" class="nav-link">
        <span class="link-text">{{ 'HOME.NAV.OFFERS' | translate }}</span>
        <div class="link-underline"></div>
      </a>
      <a (click)="smoothScroll('pricing', $event)" class="nav-link">
        <span class="link-text">{{ 'HOME.NAV.PRICING' | translate }}</span>
        <div class="link-underline"></div>
      </a>
      <a (click)="smoothScroll('staff', $event)" class="nav-link">
        <span class="link-text">{{ 'HOME.NAV.STAFF' | translate }}</span>
        <div class="link-underline"></div>
      </a>
      <a (click)="smoothScroll('content', $event)" class="nav-link">
        <span class="link-text">{{ 'HOME.NAV.CONTENT' | translate }}</span>
        <div class="link-underline"></div>
      </a>
    </div>

    <div class="auth-buttons">
      <a routerLink="/login" class="login-button">
        <span class="button-text">{{ 'HOME.NAV.LOGIN' | translate }}</span>
      </a>
      <a routerLink="/register" class="register-button">
        <span class="button-icon">✨</span>
        <span class="button-text">{{ 'HOME.NAV.REGISTER' | translate }}</span>
        <div class="button-glow"></div>
      </a>
      <!-- Language Switcher -->
      <div class="language-switcher-dropdown" (click)="toggleLanguageDropdown()" [class.open]="isLanguageDropdownOpen">
        <div class="language-switcher-button">
          <div class="language-flag">{{getLanguageFlag(currentLanguage.code)}}</div>
          <span class="language-code">{{currentLanguage.code.toUpperCase()}}</span>
        </div>
        <div class="language-dropdown" *ngIf="isLanguageDropdownOpen">
          <div class="language-option"
               *ngFor="let language of availableLanguages"
               [class.active]="language.code === currentLanguage.code"
               (click)="selectLanguage(language.code, $event)">
            <div class="language-flag">{{getLanguageFlag(language.code)}}</div>
            <span class="language-name">{{language.nativeName}}</span>
          </div>
        </div>
      </div>

      <div class="theme-switcher-dropdown" (click)="toggleDropdown()" [class.open]="isDropdownOpen">
        <div class="theme-switcher-button">
          <div class="theme-icon">🎨</div>
          <div class="theme-indicator" [style.background]="getThemeGradient(currentTheme)"></div>
        </div>
        <div class="theme-dropdown" *ngIf="isDropdownOpen">
          <div class="theme-option"
               *ngFor="let theme of availableThemes"
               [class.active]="theme.id === currentTheme.id"
               (click)="selectTheme(theme, $event)">
            <div class="theme-color-preview" [style.background]="getThemeGradient(theme)"></div>
            <span class="theme-name">{{theme.name}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Hamburger menu button -->
    <button class="hamburger-btn" (click)="toggleMenu()">
      <i class="fas fa-bars"></i>
    </button>
  </div>
</nav>

<!-- Mobile Menu Panel -->
<div class="mobile-menu" [class.open]="isMenuOpen">
  <div class="menu-header">
    <h3>{{ 'HOME.NAV.MENU' | translate }}</h3>
    <button class="close-btn" (click)="toggleMenu()">×</button>
  </div>
  <div class="menu-content">
    <!-- Navigation Links -->
    <nav class="mobile-nav">
      <a (click)="smoothScroll('home', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-home"></i>
        <span>{{ 'HOME.NAV.HOME' | translate }}</span>
      </a>
      <a (click)="smoothScroll('about', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-info-circle"></i>
        <span>{{ 'HOME.NAV.ABOUT' | translate }}</span>
      </a>
      <a (click)="smoothScroll('features', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-star"></i>
        <span>{{ 'HOME.NAV.FEATURES' | translate }}</span>
      </a>
      <a (click)="smoothScroll('offers', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-tags"></i>
        <span>{{ 'HOME.NAV.OFFERS' | translate }}</span>
      </a>
      <a (click)="smoothScroll('pricing', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-dollar-sign"></i>
        <span>{{ 'HOME.NAV.PRICING' | translate }}</span>
      </a>
      <a (click)="smoothScroll('staff', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-users"></i>
        <span>{{ 'HOME.NAV.OUR_TEAM' | translate }}</span>
      </a>
      <a (click)="smoothScroll('content', $event); toggleMenu()" class="mobile-nav-link">
        <i class="fas fa-book"></i>
        <span>{{ 'HOME.NAV.RESOURCES' | translate }}</span>
      </a>
    </nav>

    <!-- Language Switcher for Mobile -->
    <div class="mobile-language-section">
      <h4 class="section-title">{{ 'HOME.NAV.LANGUAGE' | translate }}</h4>
      <div class="mobile-language-options">
        <div class="mobile-language-option"
             *ngFor="let language of availableLanguages"
             [class.active]="language.code === currentLanguage.code"
             (click)="selectLanguage(language.code, $event)">
          <div class="language-flag">{{getLanguageFlag(language.code)}}</div>
          <span class="language-name">{{language.nativeName}}</span>
          <i class="fas fa-check" *ngIf="language.code === currentLanguage.code"></i>
        </div>
      </div>
    </div>

    <!-- Auth Buttons -->
    <div class="mobile-auth">
      <a routerLink="/login" class="mobile-auth-btn login" (click)="toggleMenu()">
        <i class="fas fa-sign-in-alt"></i>
        <span>{{ 'HOME.NAV.LOGIN' | translate }}</span>
      </a>
      <a routerLink="/auth/register" class="mobile-auth-btn register" (click)="toggleMenu()">
        <i class="fas fa-user-plus"></i>
        <span>{{ 'HOME.NAV.SIGN_UP_FREE' | translate }}</span>
      </a>
    </div>
  </div>
</div>

<!-- Menu Overlay -->
<div class="menu-overlay" [class.active]="isMenuOpen" (click)="toggleMenu()"></div>